import { useReactiveVar } from '@apollo/client';

import { useCareerApplicationsListQuery } from 'core/graphql';
import { authState } from 'core/state';
import { isCareerViewer } from 'core/hooks/CareerCenter/isCareerViewer';

import { ICareerApplication, transformCareerApplications } from './transform';
import { useCareerCapabilitySkip } from './useCareerCapabilitySkip';

interface IUseCareerApplications {
  applications: ICareerApplication[];
  loading: boolean;
  error: string;
  refetch: () => void;
}

/**
 * Журнал поиска работы студента.
 *
 * `skip` по зрителю раздела — тот же механизм, что у остальных карьерных
 * хуков: преподавателю сервер отбивает поле, и без пропуска каждая страница
 * копила бы молчаливые PermissionDenied в консоль.
 */
export const useCareerApplications = (status?: string): IUseCareerApplications => {
  const { active_role, isDemoUser } = useReactiveVar(authState);
  // Третья из трёх возможностей: журнал закрыт вместе с разделом, и без
  // пропуска закрытый пользователь платил бы запросом на каждый заход.
  const lockedSkip = useCareerCapabilitySkip('applications');
  const skip = !isCareerViewer(active_role) || Boolean(isDemoUser) || lockedSkip;

  const { data, loading, error, refetch } = useCareerApplicationsListQuery({
    variables: { status: status || null },
    fetchPolicy: 'cache-and-network',
    skip,
  });

  return {
    applications: skip ? [] : transformCareerApplications(data),
    loading,
    error: error?.message || '',
    refetch,
  };
};
